import { Component, OnInit } from '@angular/core';
import { IHelp } from '@ebb-v2/ebb-integration';
import { HelpApiService } from '../../../../services/data/help-api.service';
@Component({
  selector: 'ebb-not-qualified',
  templateUrl: './not-qualifiedpolicy.component.html',
  styleUrls: ['./not-qualifiedpolicy.component.scss']
})

export class NotQualifiedPolicyComponent implements OnInit {
  public listHelp: IHelp[] = [];
  public message: string;
  public showMessage:boolean =false;
  constructor( private readonly apiHelp: HelpApiService) { }
  
  ngOnInit() {
    this.loadHelpText();
  }
  private loadHelpText(): void {
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));

          const indexHelpContractor = this.listHelp.findIndex(i => i.name.toLowerCase() === 'ceabbregistrationnotqualified');
          this.message = this.listHelp[indexHelpContractor].answer;
          this.showMessage = true;
        },
        error => console.log(error)
      );
  }

}
